import ScrollCarousel from "./ScrollCarousel";

import { useState } from "react";

import foundation_one from "../../../assets/photos/foundation/1.png";

import MobileCard from "./MobileCard";

const productItems = [
  {
    title: "Skill Graph",
    description:
      "A platform that enhances students' competitive coding skills to strengthen their resumes with notable achievements.",
    rating: 4.5,
    views: 434,
    url: "https://ccc.training/",
  },
  {
    title: "RazorHire",
    description:
      "Simplify your resume experience with a user-friendly platform, offering tailored templates to boost your job applications.",
    rating: 4.5,
    views: 250,
    url: "https://razorhire.nxtagent.ai",
  },
  // {
  //   title: "NxtAIQ",
  //   description:
  //     "AI-powered ideathons with auto evaluation, plagiarism checks, and smart judging dashboards.",
  //   rating: 4,
  //   views: 433,
  //   url: "http://nxtaiq.com",
  // },
  {
    title: "Jayaho",
    description:
      "A platform that empowers students with essential coding, math, and tech skills through innovative and competitive courses.",
    rating: 4,
    views: 450,
    url: "https://jayaho.school/",
  },
];

const trainingItems = [
  {
    title: "B.Tech, Computer Science (Product Engineering with AI)",
    description:
      "A work-integrated program in collaboration with the university that develops future-ready engineers skilled in product development, AI and real-world problem-solving.",
    rating: 4.5,
    views: 434,
  },
  {
    title: "Future Tech Skills (Skill Graph)",
    description:
      "We offer training for placement, emphasizing employability skills, interview preparation, and professional development.",
    rating: 4.5,
    views: 434,
    url: "https://www.skillgraph.school/",
  },
  {
    title: "Soft Skills (Prapti)",
    description:
      "Training students on quantitative, verbal and reasoning skills for campus placements and competitive exams with industry-aligned methodologies.",
    rating: 4,
    views: 234,
    url: "https://prapti.school/",
  },
  {
    title: "Certification Programs (Nvedika) ",
    description:
      "Guided certification pathways aligned with global standards, enabling upskilling through structured industry-recognized credentials.",
    rating: 4.5,
    views: 234,
    url: "https://www.nvedika.com/",
  },
  {
    title: "Corporate Training",
    description:
      "We deliver corporate training focusing on leadership, team development, and performance enhancement strategies.",
    rating: 4,
    views: 234,
  },
];

const consultingItems = [
  {
    title: "Strategic Workshops",
    description:
      "We empower teams with leadership skills like strategic thinking, communication, and team building through workshops.",
    rating: 4.5,
    views: 434,
  },
  {
    title: "Maturity Assessments",
    description:
      "We help organizations optimize processes with tailored frameworks, maturity models, assessments, and strategic recommendations.",
    rating: 4.5,
    views: 434,
  },
  {
    title: "Data & Metric Management",
    description:
      "Our consulting services help organizations establish metrics, collect data, and make data-driven decisions.",
    rating: 4.5,
    views: 234,
  },
  {
    title: "Business Governance",
    description:
      "Driving business, product, project and program governance with deployment planning and action tracking for transparency, compliance and growth.",
    rating: 4.5,
    views: 234,
  },
  {
    title: "Change Management",
    description:
      "Driving transformation through leadership alignment, change acceptance, and streamlined vision, mission, and objectives.",

    rating: 4,
    views: 230,
  },
];

const realEstateItems = [
  {
    title: "Farm Plots",
    description:
      "We specialize in farm plots, offering expert guidance on land acquisition and investment.",
    rating: 4.5,
    views: 434,
  },
  {
    title: "Construction",
    description:
      "We support construction projects with land acquisition, project management, and regulatory compliance.",
    rating: 4.5,
    views: 434,
  },
  {
    title: "Commerical Leasing",
    description:
      "We offer commercial realty services, specializing in property acquisition, leasing, and investment opportunities.",
    rating: 4.5,
    views: 434,
  },
];

const subsidiariesItems = [
  {
    title: "CCC School of Technology",
    description:
      "Delivering industry-aligned technology education, certifications and hands-on learning to build future technology professionals.",
    image: foundation_one,
    rating: 4.5,
    views: 434,
    url: "https://www.cccsot.com/",
  },
  {
    title: "NxtAgent",
    description:
      "An AI-powered platform enabling intelligent automation, agentic workflows and enterprise productivity solutions.",
    image: foundation_one,
    rating: 4.5,
    views: 434,
    url: "https://www.nxtagent.ai/",
  },
  {
    title: "Campus Corporate Connect",
    description:
      "Bridging academia and industry through internships, employability programs, corporate training and career development.",
    image: foundation_one,
    rating: 4.5,
    views: 434,
    url: "https://cccsnv.com/",
  },
  {
    title: "ISF Gurukul",
    description:
      "Building a startup ecosystem that empowers exponential growth through innovation, mentorship, and entrepreneurship.",
    image: foundation_one,
    rating: 4.5,
    views: 434,
  },
];

const servicesItems = [
  {
    title: "Recruitment Services (Vysaha)",
    description:
      "We provide recruitment services to find and place top talent for your organization.",
    rating: 4.5,
    views: 434,
    url: "https://www.vysaha.com/",
  },
  {
    title: "Resource Augmentation",
    description:
      "We provide skilled professionals to meet your project needs and enhance team capabilities",
    rating: 4,
    views: 503,
  },
  {
    title: "Hire-Train-Deploy",
    description:
      "We recruit, train, and integrate skilled professionals to seamlessly join and support your team.",
    rating: 4.5,
    views: 434,
  },
];

const aiAgentsItems = [
  {
    title: "Skill Agent",
    description:
      "Practice and Maps technical and soft skills essential for education and employment.",
    rating: 4.5,
    views: 478,
    url: "https://sat.nxtagent.ai/auth/login",
  },
  {
    title: "Academic Agent",
    description:
      "Assesses academic strengths, weaknesses, and readiness for further learning.",
    rating: 4.5,
    views: 478,
  },
  {
    title: "Interview Agent",
    description:
      "Prepares students for real-world interviews through mock sessions and feedback.",
    rating: 4.5,
    views: 478,
  },
];

const academicsItems = [
  {
    title: "B.Tech, Computer Science (Product Engineering with AI)",
    description:
      "A work-integrated program in collaboration with the university that develops future-ready engineers skilled in product development, AI and real-world problem-solving.",
    rating: 4.5,
    views: 434,
  },
  {
    title: "Future Tech Skills (Skill Graph)",
    description:
      "We offer training for placement, emphasizing employability skills, interview preparation, and professional development.",
    rating: 4.5,
    views: 434,
    url: "https://www.skillgraph.school/",
  },
  {
    title: "Soft Skills (Prapti)",
    description:
      "Training students on quantitative, verbal and reasoning skills for campus placements and competitive exams with industry-aligned methodologies.",
    rating: 4,
    views: 234,
    url: "https://prapti.school/",
  },
  {
    title: "Certification Programs (Nvedika) ",
    description:
      "Guided certification pathways aligned with global standards, enabling upskilling through structured industry-recognized credentials.",
    rating: 4.5,
    views: 234,
    url: "https://www.nvedika.com/",
  },
  {
    title: "Corporate Training",
    description:
      "We deliver corporate training focusing on leadership, team development, and performance enhancement strategies.",
    rating: 4,
    views: 234,
  },
];

const OurBusiness = ({ businessSectionRef }) => {
  const initialNavigation = [
    {
      name: "AI Agents",
      href: "#",
      current: true,
      content: <ScrollCarousel items={aiAgentsItems} type={"agent"} />,
      mobileContent: <MobileCard item={aiAgentsItems} type={"agent"} />,
    },
    {
      name: "Products",
      href: "#",
      current: false,
      content: <ScrollCarousel items={productItems} type={"product"} />,
      mobileContent: <MobileCard item={productItems} type={"product"} />,
    },
    {
      name: "Academics",
      href: "#",
      current: false,
      content: <ScrollCarousel items={academicsItems} type={"academic"} />,
      mobileContent: <MobileCard item={academicsItems} type={"academic"} />,
    },
    {
      name: "Training",
      href: "#",
      current: false,
      content: <ScrollCarousel items={trainingItems} type={"training"} />,
      mobileContent: <MobileCard item={trainingItems} type={"training"} />,
    },
    {
      name: "Consulting",
      href: "#",
      current: false,
      content: <ScrollCarousel items={consultingItems} type={"consulting"} />,
      mobileContent: <MobileCard item={consultingItems} type={"consulting"} />,
    },
    {
      name: "Incubation",
      href: "#",
      current: false,
      content: <ScrollCarousel items={servicesItems} type={"incubation"} />,
      mobileContent: <MobileCard item={servicesItems} type={"incubation"} />,
    },
    {
      name: "Workforce",
      href: "#",
      current: false,
      content: <ScrollCarousel items={realEstateItems} type={"workforce"} />,
      mobileContent: <MobileCard item={realEstateItems} type={"workforce"} />,
    },
    {
      name: "Subsidiaries",
      href: "#",
      current: false,
      content: <ScrollCarousel items={subsidiariesItems} type={"subsidiaries"} />,
      mobileContent: <MobileCard item={subsidiariesItems} type={"subsidiaries"} />,
    },
  ];

  const [navigation, setNavigation] = useState(initialNavigation);

  const handleClick = (name) => {
    setNavigation((prevNavigation) =>
      prevNavigation.map((item) =>
        item.name === name
          ? { ...item, current: true }
          : { ...item, current: false },
      ),
    );
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const currentItem = navigation.find((item) => item.current);

  return (
    <div
      className="flex flex-col items-center justify-center py-24 lg:mx-28"
      ref={businessSectionRef}
    >
      <h2 className="text-4xl font-pt-sans font-bold text-[#2F2F2F] sm:mb-32 mb-32 lg:mb-6">
        Our Businesses
      </h2>

      <div className="flex flex-col lg:flex-row w-full">
        {/* Sidebar */}
        <nav
          aria-label="Sidebar"
          className="flex-shrink-0 w-full lg:w-64 lg:mt-6 sm:mt-0 mt-0 mb-10 sm:mb-10 lg:mb-0"
        >
          <ul
            className="
        flex 
        space-x-4 
        overflow-x-auto 
        px-4 
        scrollbar-hide
        md:space-x-6
        lg:flex-col 
        lg:space-x-0 
        lg:space-y-1 
        lg:overflow-x-visible 
        lg:px-0
      "
          >
            {navigation.map((item) => (
              <li
                onClick={() => handleClick(item.name)}
                className={classNames(
                  "cursor-pointer flex-shrink-0",
                  item.current ? "" : "hover:bg-gray-200",
                )}
                key={item.name}
              >
                <div
                  className={classNames(
                    item.current
                      ? "xl:border-l-4 border-l-2 font-semibold border-custom-gold text-custom-gold"
                      : "text-gray-700",
                    "group flex gap-x-3 px-3 xl:py-2 py-0.5 text-lg font-pt-sans text-nowrap",
                  )}
                >
                  {item.name}
                </div>
              </li>
            ))}
          </ul>
        </nav>
        <main className="flex-1 overflow-hidden">
          <div className="w-full max-w-[1200px] mx-auto">
            <div className="w-full block xl:hidden">
              {currentItem?.mobileContent}
            </div>
            <div className="min-h-[472px] w-full overflow-hidden xl:block hidden">
              {currentItem?.content}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default OurBusiness;
